import * as api from './middleware/api.middleware';
import { IForwardMessageRequest } from '../interfaces/forwardmessage.interfaces';
import { IBatchResponse } from '../interfaces/general.interfaces';

const serviceUrl = '/messageforwardservice/v2';

export function forwardMessage(mailboxId: string, message: IForwardMessageRequest) {
    return api.post<IBatchResponse<any>>(`${serviceUrl}/mailboxes/${mailboxId}/message-forward`, message);
}
